var $42b05097f4e27f73$exports = {};
$42b05097f4e27f73$exports = {
    "loading": `Laster inn ...`,
    "placeholder": `Velg \u{2026}`
};


export {$42b05097f4e27f73$exports as default};
//# sourceMappingURL=nb-NO.module.js.map
